import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IAccelerationNeedsScheduleParams {
  targetIds: string[];
}

export interface IAccelerationNeedsScheduleResult extends IResult {
  needsSchedule: boolean;
}

export class AccelerationNeedsScheduleRequest extends
    Request<IAccelerationNeedsScheduleParams, IAccelerationNeedsScheduleResult> {
  constructor(params: IAccelerationNeedsScheduleParams) {
    super('accelerationNeedsSchedule', params);
  }
}
